<template>
  <div class="NewsDetails">
    <div class="news-banner"></div>
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">

        <p class="product-title">{{newsIdList.Title}}</p>
        <p class="product-time">{{newsIdList.CreateTime}}</p>
        <div class="product-content">
          <p v-for="(txt, index) in newsIdList.Content.split(/[\r\n]+/)" :key="index" v-if="txt.trim()">
            {{ txt }}
          </p>
        </div>
        <img v-bind:src="newsIdList.Img" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newsdetails",
  data() {
    return {
      pid: 0,
      newsIdList: {},
      hyNewsId3: {
          "Id": 3,
          "Title": "红创“碳”讯第37期",
          "Img": require("../assets/img/new/hy3.jpg"),
          "Type": 1,
          "Content": "",
          "CreateTime": "2022/05/08 07:28"
      },
      // hyNewsId1: {
      //     "Id": 1,
      //     "Title": "红创“碳”讯",
      //     "Img": require("../assets/img/new/hy2.jpg"),
      //     "Type": 1,
      //     "Content": "【重磅】1.中国将组建全国统一的能源市场，如何统一？2.国务院安全生产委员会印发《“十四五”国家安全生产规划》3.国家发改委：支持智慧能源发展，超前布局能源等基础设施建设。",
      //     "CreateTime": "2022/04/18 07:28"
      // },
      hyNewsId2: {
          "Id": 2,
          "Title": "国务院发布《新时代的中国能源发展》白皮书：加强能源输配网络建设",
          "Img": require("../../public/hy2-1.jpg"),
          "Type": 1,
          "Content": "12月21日15时，中国国务院新闻办公室召开新闻发布会发布《新时代的中国能源发展》白皮书。白皮书显示，加速发展绿氢制取、储运和应用等氢能产业链技术装备，促进氢能燃料电池技术链、氢燃料电池汽车产业链发展。支持能源各环节各场景储能应用，着力推进储能与可再生能源互补发展。支持新能源微电网建设，形成发储用一体化局域清洁供能系统。\r\n据白皮书显示，中国能源发展有多个世界之最：初步核算，2019年中国一次能源生产总量达39.7亿吨标准煤，为世界能源生产第一大国；截至2019年底，在运在建核电装机容量6593万千瓦，居世界第二，在建核电装机容量世界第一；截至2019年底，水电、风电、光伏发电、生物质发电装机容量分别达3.56亿千瓦、2.1亿千瓦、2.04亿千瓦、2369万千瓦，均位居世界首位；截至2019年底，全国电动汽车充电基础设施达120万处，建成世界最大规模充电网络。\r\n白皮书中提到：\r\n加强能源输配网络建设。持续加强跨省跨区骨干能源输送通道建设，提升能源主要产地与主要消费区域间通达能力，促进区域优势互补、协调发展。提升既有铁路煤炭运输专线的输送能力，持续提升铁路运输比例和煤炭运输效率。推进天然气主干管道与省级管网、液化天然气接收站、储气库间互联互通，加快建设“全国一张网”，初步形成调度灵活、安全可靠的天然气输运体系。稳步推进跨省跨区输电通道建设，扩大西北、华北、东北和西南等区域清洁能源配置范围。完善区域电网主网架，加强省级区域内部电网建设。开展柔性直流输电示范工程建设，积极建设能源互联网，推动构建规模合理、分层分区、安全可靠的电力系统。\r\n在建设多元清洁的能源供应体系方面，加快抽水蓄能电站建设，推动储能与新能源发电、电力系统协调优化运行，开展电化学储能等调峰试点。完善电价、气价政策，引导电力、天然气用户自主参与调峰、错峰，提升需求侧响应能力。健全电力和天然气负荷可中断、可调节管理体系，挖掘需求侧潜力。\r\n在发挥科技创新第一动力作用方面，布局建设40多个国家重点实验室和一批国家工程研究中心，重点围绕煤炭安全绿色智能开采、可再生能源高效利用、储能与分布式能源等技术方向开展相关研究，促进能源科技进步。开展先进能源技术装备的重大能源示范工程建设，提升可再生能源发电、燃气轮机、储能、先进电网、煤炭深加工等领域装备的技术水平。加速发展绿氢制取、储运和应用等氢能产业链技术装备，促进氢能燃料电池技术链、氢燃料电池汽车产业链发展。支持能源各环节各场景储能应用，着力推进储能与可再生能源互补发展。支持新能源微电网建设，形成发储用一体化局域清洁供能系统。推动综合能源服务新模式，实现终端能源多能互补、协同高效。\r\n在全面深化能源体制改革方面，积极培育配售电、储能、综合能源服务等新兴市场主体。深化国有能源企业改革，支持非公有制发展，积极稳妥开展能源领域混合所有制改革，激发企业活力动力。",
          "CreateTime": "2020/12/21 15:48:36"
      },
      zhNewsId11: {
          "Id": 11,
          "Title": "热烈祝贺湖北中恒善能电力技术有限公司成立",
          "Img": require("../../public/zh1-1.jpg"),
          "Type": 1,
          "Content": "      热烈祝贺湖北中恒善能电力技术有限公司成立，作为电力行业具备自主创新的企业，中恒善能提供以数字化智能终端为基础，结合无线物联网、大数据、人工智能等技术，助力能源互联网的实现，推动电力生产及运营更高效、更安全。公司围绕新能源及人工智能快速发展的机遇，坚持以电力行业需求为导向，以技术革新为核心发展战略，主要推进人工智能技术加快数字化智能终端在电力数字化方面的应用，并结合电力需求进行无线供能技术、无线传感技术及空间无线监测技术在电力物联网领域的应用设备研发及推广。 公司具有多层次多专业的科研专家团队，研发了具有行业先进水平的无线传感及监测、数字化智能终端等系列产品，革新了一些传统运维和监督模式，加快电力行业在电力物联网背景下智能高效运维和智慧安全监督的转型升级。 目前公司已经形成了博士为技术核心，大部分研发人员达到本科及以上的水平，构成了决策和执行梯度结合的水平。公司的主要产品包括：基于大数据分析的综合能源服务系统、新能源电力控制系统（配合电力国产化进展）、无线物联网系列产品、数字化智能终端系列产品。",
          "CreateTime": "2014/04/01 19:46:46"
      },
      zhNewsId12: {
          "Id": 12,
          "Title": "热烈祝贺中恒善能获得智慧配电运维管理系统软件著作权",
          "Img": require("../../public/honor4.png"),
          "Type": 1,
          "Content": "历时几个月的软件开发，热烈祝贺湖北中恒善能电力技术有限公司获得智慧配电运维管理系统软件著作权!",
          "CreateTime": "2022/02/17 16:24:11"
      },
      zhNewsId13: {
        "Id": 13,
        "Title": "聚力标准研制 赋能低碳转型",
        "Img": require("../../public/seminar.png"),
        "Type": 1,
        "Content": "  6 月 1 日，由全国燃烧节能净化标准化技术委员会（SAC/TC441）归口管理、广东佛山仙湖实验室牵头编制的两项国家标准化指导性技术文件项目启动会，在安徽合肥顺利召开。我司作为参与单位出席本次会议，同中国科学技术大学、浙江大学、安徽省市场监督管理局等多家单位的行业专家齐聚一堂，共同对《工业炉窑氨燃料燃烧装置通用技术规范》《工业氨燃烧烟气残氨激光检测方法》两项标准文稿开展评审、研讨与交流。\r\n长久以来，公司始终积极投身国家标准研制、国际标准对接及行业技术规范编制工作，先后参与多项国家标准、团体标准建设，在标准编制、技术落地等方面积累了扎实的实践经验与技术沉淀。本次深度参与工业氨燃烧领域两项国家标准指导性技术文件的研制工作，既是行业对我司在氢氨零碳燃烧、排放检测领域技术研究成果与专业能力的高度认可，也进一步提升了公司在绿色低碳赛道的综合技术支撑实力。\r\n标准引领发展，创新驱动未来。下一步，湖北中恒善能电力技术有限公司将继续立足自身技术优势，持续聚焦氢氨能源装备、燃烧检测技术核心领域，深度参与各类国家及行业标准研制工作，不断强化标准化研发与应用能力。公司将以高标准建设助力省内氢能、氨能产业规范化、高质量发展，全力为工业领域绿色低碳转型贡献专业力量。",
        "CreateTime": "2026/06/02 10:00:00"
      }
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.console.log(this.pid);
    this.judge();
  },
  mounted() {
    // this.loadData();
  },
  methods: {
    zhuanhuan() {
      this.newsList.Content  =  this.newsList.Content.replace(/[\r\n]/g,'<br>')
    },
    judge() {
      if(this.pid === 1){
        this.newsIdList = this.hyNewsId1
      } else if(this.pid === 2){
        this.newsIdList = this.hyNewsId2
      } else if(this.pid === 3){
        this.newsIdList = this.hyNewsId3
      } else if(this.pid === 11) {
        this.newsIdList = this.zhNewsId11
      } else if(this.pid === 12) {
        this.newsIdList = this.zhNewsId12
      } else if(this.pid === 13) {
        this.newsIdList = this.zhNewsId13
      }
    }
    // loadData() {
    //   this.$http
    //     .get(`News/GetNewsById/${this.pid}`)
    //     .then(response => {
    //       //console.log(response);
    //       this.newsIdList = response.data;
    //       window.console.log(this.newsIdList);
    //     })
    //     .catch(function(error) {
    //       window.console.log(error);
    //     });
    // }
  }
};
</script>

<style lang="scss" scoped>
br {
  margin-top: 5px;
  margin-bottom: 5px;
}
.NewsDetails {
  width: 100%;
  height: 100%;
  //overflow: hidden;
//   background-color: #14679f;

  .news-banner {
      width: 100%;
      height: 405px;
      background: url(../assets/img/bgtop_news.jpg) center;
    }
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    // border: 1px solid red;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        // height: 500px;
      }
      .product-title {
        font-size: 25px;
        line-height: 60px;
        // color: #e13834;
        text-align: center;
        // padding: 20px 0;
        border-bottom: 1px solid #f1f1f1;
      }
      .product-time {
        display: block;
        padding: 10px 0 50px;
        text-align: right;
        font-size: 12px;
        color: #999;
      }
      .product-content {
        // font-size: 17px;
        // padding: 20px 0;
        margin-top: 0px;
        margin-bottom: 0px;
        max-width: 100%;
        clear: both;
        min-height: 1em;
        line-height:30px;
        color: rgb(35, 45, 98);
        font-family: -apple-system-font, BlinkMacSystemFont, "Helvetica Neue", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei UI", "Microsoft YaHei", Arial, sans-serif;
        font-size: 14px;
        letter-spacing: 1.5px;
        text-align: justify;
        white-space: normal;
        text-indent: 2em;
        background-color: rgb(254, 254, 254);
        box-sizing: border-box !important;
        overflow-wrap: break-word !important;
      }
    }
  }
  .product-title {
      width: 100%;
  }
  .product-time {
      width: 100%;
  }
}
</style>